let lockCount = 0

export default {
    mounted() {
        lockCount++
        document.documentElement.classList.add('scroll-locked')
    },
    beforeDestroy() {
        lockCount = Math.max(0, lockCount - 1)
        if (lockCount === 0) document.documentElement.classList.remove('scroll-locked')
    }
}
